import { useState } from 'react';
import { useTranslations } from 'use-intl';

import { Exceptions } from '@blockpulse3/data/shared';
import {
  EmailVerificationStatus,
  useCreateUserMutation,
  useLoginMutation,
} from '@blockpulse3/graphql/hooks';
import { useErrorToast } from '@blockpulse3/ui/commons';

import { useUser } from '../../providers';
import { CheckEmail } from '../CheckEmail';
import { ISignUpForm, SignUpForm } from '../SignUpForm';

type Props = unknown;

export function SignUpView(): JSX.Element {
  const i18nSignUpForm = useTranslations('SignUpForm');

  const { loadUser } = useUser();

  const errorToast = useErrorToast();

  const [createUser, { loading }] = useCreateUserMutation();
  const [login] = useLoginMutation();
  const [tokenType, setTokenType] = useState<string>('');
  const [signUpEmail, setSignUpEmail] = useState<string>('');

  /* Callbacks */
  const handleSignUpSubmit = (signupData: ISignUpForm): void => {
    if (loading) {
      return undefined;
    }

    createUser({
      variables: {
        createUserInput: {
          firstName: '',
          lastName: '',
          email: signupData.email,
          password: signupData.password,
          timezone: signupData.timezone,
        },
      },
      onCompleted: (result) => {
        setSignUpEmail(signupData.email);
        login({
          variables: {
            loginInput: {
              email: result.createUser.email,
              password: signupData.password,
              timezone: signupData.timezone,
            },
          },
          onCompleted: (data) => {
            setTokenType(data?.login?.process_step || '');
            if (data?.login?.access_token) {
              localStorage.setItem('token', data.login.access_token);
              loadUser();
            }
          },
        });
      },
      onError: (err: unknown) => {
        const error = err as Error;
        if (error.message === Exceptions.AlreadyUsedEmail) {
          errorToast({ title: i18nSignUpForm('Toast.AlreadyUsedEmail') });
        } else {
          errorToast({ title: i18nSignUpForm('Toast.Error') });
        }
      },
    });
  };

  if (tokenType === EmailVerificationStatus.UNVERIFIED) {
    return <CheckEmail email={signUpEmail} />;
  }

  return <SignUpForm loading={loading} onSubmit={handleSignUpSubmit} />;
}

export type SignUpViewProps = Props;
